'use client';

import { VipClubBanner } from './VipClubBanner';
import { VipClubIntro } from './VipClubIntro';
import { VipClubLevel } from './VipClubLevel';
import { VipClubQuestion } from './VipClubQuestion';
import { VipClubReward } from './VipClubReward';
import { VipClubWork } from './VipClubWork';
export const VipClub: React.FC = () => {
  return <>
      <VipClubBanner />
      <VipClubIntro />
      <VipClubWork />
      <VipClubReward />
      <VipClubLevel />
      <VipClubQuestion />
    </>;
};